// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SecondBlock_root__fC1yU {
  position: relative;
  padding: 40px 0;
}
.SecondBlock_root__fC1yU .SecondBlock_titleBlock__sl8dK {
  font-size: 26px;
  font-weight: bold;
  color: #00377c;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 {
  min-height: calc(100vh - 196px);
  padding: 40px 0;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_imgBlock__h9BDI img {
  max-width: 90%;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK ul li {
  margin-bottom: 10px;
  padding: 5px 10px;
  white-space: nowrap;
  background: #d9d9d9;
  border-radius: 20px;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK ul li:first-child .SecondBlock_circle__aEZQF {
  background: #f8bc10;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK ul li:nth-child(2) .SecondBlock_circle__aEZQF {
  background: #d31213;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK ul li:nth-child(3) .SecondBlock_circle__aEZQF {
  background: #b119d7;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK ul li:nth-child(4) .SecondBlock_circle__aEZQF {
  background: #1e6daf;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK ul li:nth-child(5) .SecondBlock_circle__aEZQF {
  background: #0ca352;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK ul li:nth-child(6) .SecondBlock_circle__aEZQF {
  background: #94c866;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK ul li:nth-child(7) .SecondBlock_circle__aEZQF {
  background: #b57700;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK ul li:last-child {
  margin-bottom: 0;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK ul li .SecondBlock_circle__aEZQF {
  margin-left: -13px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #b52b00;
}
.SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK ul li span {
  margin-left: 4px;
}
.SecondBlock_root__fC1yU .SecondBlock_btnBlock__3v2yc button {
  padding: 10px 20px;
  color: #fff;
  background: #1b51e3;
  border: none;
  border-radius: 20px;
}
.SecondBlock_root__fC1yU .SecondBlock_btnBlock__3v2yc button:hover {
  background: #1e5aff;
}
.SecondBlock_root__fC1yU .SecondBlock_btnBlock__3v2yc button:active {
  background: #153dac;
}
.SecondBlock_root__fC1yU .SecondBlock_btnBlock__3v2yc button svg {
  font-size: 26px;
}

@media (max-width: 991px) {
  .SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_imgBlock__h9BDI {
    display: flex;
    justify-content: center;
  }
  .SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_imgBlock__h9BDI img {
    max-width: 100%;
  }
  .SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 .SecondBlock_infoBlock__mVIYK {
    display: none;
  }
}
@media (max-width: 768px) {
  .SecondBlock_root__fC1yU {
    padding: 20px 0;
  }
  .SecondBlock_root__fC1yU .SecondBlock_titleBlock__sl8dK {
    font-size: 18px;
  }
  .SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 {
    min-height: calc(100vh - 123px);
    padding: 20px 0;
  }
  .SecondBlock_root__fC1yU .SecondBlock_btnBlock__3v2yc button {
    padding: 4px 8px;
    font-size: 14px;
    border-radius: 15px;
  }
  .SecondBlock_root__fC1yU .SecondBlock_btnBlock__3v2yc button svg {
    font-size: 18px;
  }
}
@media (max-width: 500px) {
  .SecondBlock_root__fC1yU .SecondBlock_titleBlock__sl8dK {
    font-size: 16px;
  }
  .SecondBlock_root__fC1yU .SecondBlock_mapBlock__Bui62 {
    min-height: calc(100vh - 114px);
  }
  .SecondBlock_root__fC1yU .SecondBlock_btnBlock__3v2yc button {
    font-size: 12px;
  }
  .SecondBlock_root__fC1yU .SecondBlock_btnBlock__3v2yc button svg {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MainBlock/SecondBlock/SecondBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;AACF;AACE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AACJ;AAEE;EACE,+BAAA;EACA,eAAA;AAAJ;AAGM;EACE,cAAA;AADR;AAOQ;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AALV;AAQY;EACE,mBAAA;AANd;AAWY;EACE,mBAAA;AATd;AAcY;EACE,mBAAA;AAZd;AAiBY;EACE,mBAAA;AAfd;AAoBY;EACE,mBAAA;AAlBd;AAuBY;EACE,mBAAA;AArBd;AA0BY;EACE,mBAAA;AAxBd;AA4BU;EACE,gBAAA;AA1BZ;AA6BU;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AA3BZ;AA8BU;EACE,gBAAA;AA5BZ;AAoCI;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAlCN;AAoCM;EACE,mBAAA;AAlCR;AAqCM;EACE,mBAAA;AAnCR;AAsCM;EACE,eAAA;AApCR;;AA0CA;EAGM;IACE,aAAA;IACA,uBAAA;EAzCN;EA2CM;IACE,eAAA;EAzCR;EA6CI;IACE,aAAA;EA3CN;AACF;AAgDA;EACE;IACE,eAAA;EA9CF;EAgDE;IACE,eAAA;EA9CJ;EAiDE;IACE,+BAAA;IACA,eAAA;EA/CJ;EAmDI;IACE,gBAAA;IACA,eAAA;IACA,mBAAA;EAjDN;EAmDM;IACE,eAAA;EAjDR;AACF;AAuDA;EAEI;IACE,eAAA;EAtDJ;EAyDE;IACE,+BAAA;EAvDJ;EA2DI;IACE,eAAA;EAzDN;EA2DM;IACE,eAAA;EAzDR;AACF","sourcesContent":[".root {\n  position: relative;\n  padding: 40px 0;\n\n  .titleBlock {\n    font-size: 26px;\n    font-weight: bold;\n    color: #00377c;\n  }\n\n  .mapBlock {\n    min-height: calc(100vh - 196px);\n    padding: 40px 0;\n\n    .imgBlock {\n      img {\n        max-width: 90%;\n      }\n    }\n\n    .infoBlock {\n      ul {\n        li {\n          margin-bottom: 10px;\n          padding: 5px 10px;\n          white-space: nowrap;\n          background: #d9d9d9;\n          border-radius: 20px;\n\n          &:first-child {\n            .circle {\n              background: #f8bc10;\n            }\n          }\n\n          &:nth-child(2) {\n            .circle {\n              background: #d31213;\n            }\n          }\n\n          &:nth-child(3) {\n            .circle {\n              background: #b119d7;\n            }\n          }\n\n          &:nth-child(4) {\n            .circle {\n              background: #1e6daf;\n            }\n          }\n\n          &:nth-child(5) {\n            .circle {\n              background: #0ca352;\n            }\n          }\n\n          &:nth-child(6) {\n            .circle {\n              background: #94c866;\n            }\n          }\n\n          &:nth-child(7) {\n            .circle {\n              background: #b57700;\n            }\n          }\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n\n          .circle {\n            margin-left: -13px;\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            background: #b52b00;\n          }\n\n          span {\n            margin-left: 4px;\n          }\n        }\n      }\n    }\n  }\n\n  .btnBlock {\n    button {\n      padding: 10px 20px;\n      color: #fff;\n      background: #1b51e3;\n      border: none;\n      border-radius: 20px;\n\n      &:hover {\n        background: #1e5aff;\n      }\n\n      &:active {\n        background: #153dac;\n      }\n\n      svg {\n        font-size: 26px;\n      }\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .root {\n    .mapBlock {\n      .imgBlock {\n        display: flex;\n        justify-content: center;\n\n        img {\n          max-width: 100%;\n        }\n      }\n\n      .infoBlock {\n        display: none;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    padding: 20px 0;\n\n    .titleBlock {\n      font-size: 18px;\n    }\n\n    .mapBlock {\n      min-height: calc(100vh - 123px);\n      padding: 20px 0;\n    }\n\n    .btnBlock {\n      button {\n        padding: 4px 8px;\n        font-size: 14px;\n        border-radius: 15px;\n\n        svg {\n          font-size: 18px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .root {\n    .titleBlock {\n      font-size: 16px;\n    }\n\n    .mapBlock {\n      min-height: calc(100vh - 114px);\n    }\n\n    .btnBlock {\n      button {\n        font-size: 12px;\n\n        svg {\n          font-size: 18px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SecondBlock_root__fC1yU`,
	"titleBlock": `SecondBlock_titleBlock__sl8dK`,
	"mapBlock": `SecondBlock_mapBlock__Bui62`,
	"imgBlock": `SecondBlock_imgBlock__h9BDI`,
	"infoBlock": `SecondBlock_infoBlock__mVIYK`,
	"circle": `SecondBlock_circle__aEZQF`,
	"btnBlock": `SecondBlock_btnBlock__3v2yc`
};
export default ___CSS_LOADER_EXPORT___;
